import { apiSlice } from 'store/slices/api/api-slice';

export const importTradeDataApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        categoryDelete: builder.mutation({
            query: (categoryId: string) => ({
                url: `toon-tint/category/` + categoryId,
                method: 'DELETE',
                header: {},
            }),
        }),

        categoryFileDelete: builder.mutation({
            query: (categoryId: string) => ({
                url: `toon-tint/delete-category-image/` + categoryId,
                method: 'DELETE',
                header: {},
            }),
        }),

        toonTintItemDelete: builder.mutation({
            query: (itemId: string) => ({
                url: `toon-tint/category-item/` + itemId,
                method: 'DELETE',
                header: {},
            }),
        }),
    }),
});

export const {
    useCategoryDeleteMutation,
    useCategoryFileDeleteMutation,
    useToonTintItemDeleteMutation,
} = importTradeDataApiSlice;
